import React from 'react';
import { cleanRoll } from '../../../utils/formatter';


interface RollSearchProps {
    name: string;
    id: string;
    disabled?: boolean;
    value?: string;
    maxLength?: number;
    ariaLabel?: string;
    placeholder?: string;
    autoComplete?: string;
    onChange?: (value: string) => void;
    onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
}

export default function RollSearch(props: RollSearchProps) {
    const handlePaste = (event: React.ClipboardEvent<HTMLInputElement>) => {
        event.preventDefault();
        const pastedText = event.clipboardData.getData('text');
        const cleanedRoll = cleanRoll(pastedText);


        const target = event.target as HTMLInputElement;
        target.value = cleanedRoll;

        if (props.onChange) {
            props.onChange(cleanedRoll);
        }
    };
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        const cleanedRoll = cleanRoll(value);

       if (cleanedRoll !== value) {
            event.target.value = cleanedRoll;
       }

        if (props.onChange) {
            props.onChange(cleanedRoll);
        }
    };

    return (
        <input
            name={props.name}
            id={props.id}
            type="text"
            maxLength={props.maxLength || 15}
            disabled={props.disabled}
            value={props.value}
            placeholder={props.placeholder}
            aria-label={props.ariaLabel}
            autoComplete={props.autoComplete}
            onPaste={handlePaste}
            onChange={handleChange}
            onBlur={props.onBlur}
        />
    );
}